import { Calendar, Tag } from "lucide-react";
import type { ReactNode } from "react";
import type { ActivityEvent } from "@/components/ui/ActivityFeed/types";

function formatDeadline(value: unknown): string | null {
  if (typeof value !== "number" && typeof value !== "string") return null;
  const ms = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(ms) || ms <= 0) return null;
  return new Date(ms).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function renderAuditCreated(event: ActivityEvent): ReactNode {
  const meta = event.metadata ?? {};
  // Keys are lowercased+space-split by sanitizeActivityMetadata: "displayName" → "display name"
  const auditName = meta.audit ?? meta["display name"];
  const deadline = formatDeadline(meta.deadline);
  const trigger = meta.trigger;

  if (!auditName && !deadline && !trigger) return null;

  return (
    <div className="mt-2 rounded-md border border-border/60 bg-card px-3 py-2.5 text-[12px] space-y-1.5">
      {auditName && (
        <p className="font-medium text-primary truncate">{auditName}</p>
      )}
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-muted">
        {deadline && (
          <span className="flex items-center gap-1">
            <Calendar size={11} className="shrink-0" />
            {deadline}
          </span>
        )}
        {trigger && (
          <span className="flex items-center gap-1">
            <Tag size={11} className="shrink-0" />
            {trigger}
          </span>
        )}
      </div>
    </div>
  );
}
